import moment from "moment";
export class IntAssessLog {
  CandID;
  JobAdCode;
  Seq;
  LogSeq;
  IntStatus;
  LogMsg;
  LogBy;
  DateLog;
  constructor() {
    this.CandID = "";
    this.JobAdCode = "";
    this.Seq = "";
    this.LogSeq = 0;
    this.IntStatus = "";
    this.LogMsg = "";
    this.LogBy = "";
    this.DateLog = moment().format("YYYY-MM-DD");
  }
}



// WEBPACK FOOTER //
// ./src/model/IntAssessLog.js